"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n    color: ", ";\n    font-size: ", "em;\n"], ["\n    margin-bottom: 0;\n    color: ", ";\n    font-size: ", "em;\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UserInfoText = _styledComponents2.default.p(_templateObject, function (props) {
    return props.theme.userInfo.text.color;
}, function (props) {
    return props.theme.userInfo.text.size;
});

UserInfoText.displayName = "UserInfoText";

exports.default = UserInfoText;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/userInfo/userInfoText.js
// module id = 1026
// module chunks = 95715928098905 168707334958949